import { render, staticRenderFns } from "./NccQuestionOptionBar.vue?vue&type=template&id=71d23950&scoped=true&"
import script from "./NccQuestionOptionBar.vue?vue&type=script&lang=js&"
export * from "./NccQuestionOptionBar.vue?vue&type=script&lang=js&"
import style0 from "./NccQuestionOptionBar.vue?vue&type=style&index=0&id=71d23950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d23950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/staging.newcitycatechismus.nl/httpdocs/web/app/themes/wp-subsite-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d23950')) {
      api.createRecord('71d23950', component.options)
    } else {
      api.reload('71d23950', component.options)
    }
    module.hot.accept("./NccQuestionOptionBar.vue?vue&type=template&id=71d23950&scoped=true&", function () {
      api.rerender('71d23950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/QNA/NccQuestionOptionBar.vue"
export default component.exports